import React, { useContext } from 'react';

import { MastheadData as TurnkeyMastheadData, MastheadFooterData, MastheadHeaderData } from 'lib/sanity/types';

interface MastheadProviderProps {
  turnkeyMastheadData?: TurnkeyMastheadData;
  children: React.ReactNode;
}

interface MastheadData {
  header?: MastheadHeaderData;
  footer?: MastheadFooterData;
}

const MastheadContext = React.createContext<MastheadData | null>(null);

export function useMastheadData() {
  return useContext(MastheadContext);
}

const MastheadProvider: React.FC<MastheadProviderProps> = ({ children, turnkeyMastheadData }) => {
  return (
    <MastheadContext.Provider
      value={{
        header: turnkeyMastheadData?.header,
        footer: turnkeyMastheadData?.footer,
      }}
    >
      {children}
    </MastheadContext.Provider>
  );
};

export default MastheadProvider;
